<template>
    <div class="space-y-3 overflow-y-auto overscroll-none scrollbar-thin scrollbar-track-white scrollbar-thumb-indigo-100 pl-1 pr-4">
        <checkbox v-model="form.task_settings.generate_pdf"
                  label="Generate Task Card PDF"
                  description="A PDF will be sent to the service provider's email and added to the ticket's documents for later use"
                  description-styling="text-xs"
                  label-styling="text-md font-normal">
        </checkbox>
        <!-- Task Card options -->
        <transition name="slide">
            <div v-show="form.task_settings.generate_pdf" class="space-y-3">
                <div>
                    <text-area v-model="form.task_settings.instruction_message"
                               input-label="Special instructions"
                               placeholder="Optional"
                               :resizable="false"
                               rows="3" class="resize-none">
                        <label slot="label" class="flex flex-col md:flex-row md:justify-between block text-sm font-medium leading-5 text-gray-700"
                               :for="(Math.random() * 99999).toFixed(0)">
                            <span>Special instructions</span>

                            <span class="text-red-500 text-sm font-light" :class="{'block': form.errors.has('task_settings.instruction_message')}"
                                  v-show="form.errors.has('task_settings.instruction_message')">
                                {{ form.errors.get("task_settings.instruction_message") }}
                            </span>
                        </label>
                    </text-area>

                    <p class="text-xs font-light text-gray-500 w-full pt-1">A special instruction message that will be added to the Task Card PDF</p>
                </div>

                <checkbox v-model="form.task_settings.include_photos"
                          label="Include Issue Photos"
                          description="The issue photos will be present in the generated Task Card PDF"
                          description-styling="text-xs"
                          label-styling="text-md font-normal">
                </checkbox>

                <checkbox v-model="form.task_settings.include_signatures"
                          label="Include Signature Lines"
                          description="Space will be provided for a tenant and service provider signatures in the generated Task Card PDF"
                          description-styling="text-xs"
                          label-styling="text-md font-normal">
                </checkbox>
            </div>
        </transition>

        <checkbox v-model="form.task_settings.show_landlord_details"
                  label="Share Landlord Details"
                  description="Landlord details will be visible to the service provider on the Task Card and Task Card PDF"
                  description-styling="text-xs"
                  label-styling="text-md font-normal">
        </checkbox>

        <checkbox v-model="form.task_settings.show_tenant_details"
                  label="Share Tenant Details"
                  description="Tenant details will be visible to the service provider on the Task Card and Task Card PDF"
                  description-styling="text-xs"
                  label-styling="text-md font-normal">
        </checkbox>

        <checkbox v-model="form.task_settings.requires_quality_assurance_sign_off"
                  v-if="hasFeature('feat_service_provider_portals')"
                  label="Requires Tenant Quality Assurance Sign-off"
                  description="The service provider will have to request a OTP from the tenant to confirm that the work was done to a satisfactory standard."
                  description-styling="text-xs"
                  label-styling="text-md font-normal">
        </checkbox>
    </div>
</template>

<script>
export default {
    name: "TaskServiceProviderModalSelectTaskSettings",

    props: {
        form: {
            required: true,
            type: Object,
        },
    },

    watch: {
        "form.task_settings.instruction_message": function () {
            if (this.form.errors.has("task_settings.instruction_message")) {
                this.form.errors.forget("task_settings.instruction_message");
            }
        },

        "form.task_settings.generate_pdf": function (newVal) {
            if (!newVal) {
                this.$set(this.form.task_settings, "show_landlord_details", false);
                this.$set(this.form.task_settings, "show_tenant_details", false);
                this.$set(this.form.task_settings, "requires_quality_assurance_sign_off", false);
            }
        },
    },
};
</script>